import React from "react";
import StudyShell from "@/components/study/StudyShell";
import StudyRunner from "@/components/study/StudyRunner";
import { STUDY } from "@/constants/testIds";

export default function StudyBookmarks() {
  return (
    <StudyShell testId={STUDY.bookmarksPage}>
      <h1 className="text-2xl font-bold text-[var(--ibp-ink)]">Bookmarked questions</h1>
      <p className="mt-1 text-sm text-[color:rgba(11,18,32,0.6)]">
        Questions you saved to revisit.
      </p>
      <div className="mt-6">
        <StudyRunner mode="bookmarks" emptyText="No bookmarks yet. Tap the bookmark icon on any question." />
      </div>
    </StudyShell>
  );
}
